export const validateName = (value) => {
  if (value.length > 6) {
    return true;
  }
  return false;
};

export const validateEmail = (value) => {
  if (
    /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value) &&
    value.endsWith("@indegene.com")
  ) {
    return true;
  }
  return false;
};

export const validatePassword = (value) => {
  if (/^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])[a-zA-Z\d@$!%*#?&]{6,20}$/.test(value)) {
    return true;
  }
  return false;
};

export const validatePresentationName = (value) => {
  if (value.length <= 100 && /^[a-z0-9_-]+$/i.test(value)) {
    return true;
  }
  return false;
}

export const validateKeyMessageName = (value) => {
  if (value.length <= 100 && /^[a-z0-9_-]+$/i.test(value)) {
    return true;
  }
  return false;
}

export const validateTemplateName = (value) => {
  if (value.length <= 100 && /^[a-z0-9_-]+$/i.test(value)) {
    return true;
  }
  return false;
}

export const validateImageName = (value) => {
  if (value.length <= 100 && /^[a-z0-9_.-]+$/i.test(value)) {
    return true;
  }
  return false;
}

export const validateTemplateCDN = (value) => {
  if (value.indexOf(".js") == value.length - 3 || value.length < 1) {
    return true;
  }
  return false;
}

export const validateDimensions = (value) => {
  if (/^\d+(\.\d+)?\s*(px|vw|vh|%|em|rem)$/i.test(value)) {
    return true;
  }
  return false;
}